export default {
    setDispatchConfiguration (state, data) {
        state.dispatchConfiguration = data
    },
}
